/* TODO: TOURSENTRY */
import React from 'react';
import { connect } from 'react-redux';

// import { getDepartureCityId } from '../../selectors/package';

// import { DME__FREELUGGAGE, MOSCOW_CITY_ID } from '../../constants/additionalInfo';

import { useTranslation } from '@lt/localization';
import LTExtra from '../../../../../../components/LTExtra';
import { getLtExtras } from '../../../../store/selectors/services';
import type { IExtraItemsContainer } from './types';

const baseCls = 'checkout-extraitems';

const ExtraItemsContainer = ({
  ltExtras = [],
}: IExtraItemsContainer): JSX.Element | null => {
  const { t } = useTranslation();
  return ltExtras.length > 0 ? (
    <div className={baseCls}>
      <h2 className={`${baseCls}__title `}>
        {t('checkout.packageInfo.extraItems')}
      </h2>
      {ltExtras.map((ltExtra) => (
        <LTExtra {...ltExtra} key={ltExtra.code_name} />
      ))}
    </div>
  ) : null;
};

const mapStateToProps = (state) => ({
  // departureCityId: getDepartureCityId(state),
  ltExtras: getLtExtras(state),
});

export default connect(mapStateToProps)(ExtraItemsContainer);
